import script from "./VoidAnchor.vue?vue&type=script&setup=true&lang=js"
export * from "./VoidAnchor.vue?vue&type=script&setup=true&lang=js"

import "./VoidAnchor.vue?vue&type=style&index=0&id=4703beaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4703beaa"]])

export default __exports__